const doc = [({"ja":({"inside":"内側", "outside":"海側", "balcony":"バルコニー", "suite":"スイート"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;